/* eslint-disable */

$('#toggle').click(function() {
    $(this).toggleClass('active');
    $('#overlay').toggleClass('open');
   });


/* eslint-enble */



// WEBPACK FOOTER //
// ./___src/assets/js/scripts/overlay.js